import axios from "axios";

export class OrderImagesDownloader {
    download(btn) {
        if (btn.dataset.downloadInProgress === 'true') {
            return Promise.resolve();
        }

        btn.dataset.downloadInProgress = 'true';
        document.querySelector('#loading-overlay').style.display = 'block';

        const { url, econnabortedError, downloadError } = btn.dataset;

        return axios.get(url, {
            timeout: 60000,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(apiResponse => {
            if (apiResponse && apiResponse.data) {
                if (apiResponse.data.error) {
                    alert(apiResponse.data.error);
                } else if (apiResponse.data.queued === true) {
                    alert(apiResponse.data.message);
                } else {
                    apiResponse.data.forEach(function (file) {
                        let iFrame = document.createElement('iframe');
                        iFrame.hidden = true;
                        iFrame.setAttribute('src', '/splittedzips/download/' + file)
                        document.querySelector('body').append(iFrame);
                    });
                }
            }
        })
        .catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                alert(error.response.data.error);
            } else if (error.code === 'ECONNABORTED') {
                alert(econnabortedError);
            } else {
                console.error('Order image download failed', error);
                alert(downloadError || econnabortedError);
            }
        })
        .finally(() => {
            delete btn.dataset.downloadInProgress;
            document.querySelector('#loading-overlay').style.display = 'none';
        });
    }
}
